export const primaryBlue = '#143B6B';
export const secondaryBlue = '#E8ECF1';
export const infoBlue = '#4094FC';
export const successGreen = '#3A8A14';
export const gray = '#656565';
export const disabledGray = '#D7D7D7';
export const black = '#000000';
export const warningRed = '#E31313';

export const borderBlueStyle = '6px solid #0A3D6C';
export const borderWhiteStyle = '0px solid white';
